import { all, fork, takeEvery, takeLatest } from 'redux-saga/effects';

import { LOGIN_REQUEST } from './login/action';
import { loginSaga } from './login/login';
import { POST_LOGIN } from './postLogin/action';
import { postLoginSaga } from './postLogin/postLogin';
import { LOGOUT_REQUEST } from './logout/action';
import { logoutSaga } from './logout/logout';
import { INITIALIZE_APP } from './initializeApp/action';
import { initializeAppSaga } from './initializeApp/initializeApp';
import { REFRESH_TOKEN } from './auth/refreshAccessToken/action';
import { refreshAccessTokenSaga } from './auth/refreshAccessToken/refreshAccessToken';
import { START_TOKEN_REFRESH_TIMER } from './auth/startTokenRefreshTimer/action';
import { startTokenRefreshTimerSaga } from './auth/startTokenRefreshTimer/startTokenRefreshTimer';
import { SYSTEM_SUSPEND } from './systemSuspend/action';
import { systemSuspendSaga } from './systemSuspend/systemSuspend';
import { SYSTEM_RESUME } from './systemResume/action';
import { systemResumeSaga } from './systemResume/systemResume';
import { CHECK_DEVICE, CREATE_DEVICE, FETCH_SMS_NUMBER } from './device/action';
import { checkDeviceSaga, createDeviceSaga, fetchSMSNumberSaga } from './device/device';
import { FETCH_PORTAL_CONFIG } from './portalConfig/fetchPortalConfig/action';
import { fetchPortalConfigSaga } from './portalConfig/fetchPortalConfig/fetchPortalConfig';
import { FETCH_CALL_HISTORY } from './callHistory/fetchCallHistory/action';
import { fetchCallHistorySaga } from './callHistory/fetchCallHistory/fetchCallHistory';
import { FETCH_CALL_RECORDING } from './callRecording/fetchCallRecording/action';
import { fetchCallRecordingSaga } from './callRecording/fetchCallRecording/fetchCallRecording';
import { PROCESS_CALL_RECORDING } from './callRecording/processCallRecording/action';
import { processCallRecordingSaga } from './callRecording/processCallRecording/processCallRecording';
import { FETCH_ANALYTIC_DOMAIN_SETTINGS } from './analytic/analyticAdmin/fetchDomainSettings/action';
import { fetchDomainSettingsSaga } from './analytic/analyticAdmin/fetchDomainSettings/fetchDomainSettings';
import { UPDATE_ANALYTIC_DOMAIN_SETTINGS } from './analytic/analyticAdmin/updateDomainSettings/action';
import { updateDomainSettingsSaga } from './analytic/analyticAdmin/updateDomainSettings/updateDomainSettings';
import { FETCH_ANALYTIC_DOMAIN_USERS } from './analytic/analyticAdmin/fetchDomainUsers/action';
import { fetchDomainUsersSaga } from './analytic/analyticAdmin/fetchDomainUsers/fetchDomainUsers';
import { UPDATE_ANALYTIC_DOMAIN_USER } from './analytic/analyticAdmin/updateDomainUser/action';
import { updateDomainUserSaga } from './analytic/analyticAdmin/updateDomainUser/updateDomainUser';
import { FETCH_ANALYTIC_DOMAIN_USAGE_SNAPSHOT } from './analytic/analyticAdmin/fetchDomainUsageSnapshot/action';
import { fetchDomainUsageSnapshotSaga } from './analytic/analyticAdmin/fetchDomainUsageSnapshot/fetchDomainUsageSnapshot';
import { FETCH_ANALYTIC_DOMAIN_USERS_USAGE_SNAPSHOT } from './analytic/analyticAdmin/fetchDomainUsersUsageSnapshot/action';
import { fetchDomainUsersUsageSnapshotSaga } from './analytic/analyticAdmin/fetchDomainUsersUsageSnapshot/fetchDomainUsersUsageSnapshot';
import { FETCH_ANALYTIC_DOMAIN_USAGE_HISTORY } from './analytic/analyticAdmin/fetchDomainUsageHistory/action';
import { fetchDomainUsageHistorySaga } from './analytic/analyticAdmin/fetchDomainUsageHistory/fetchDomainUsageHistory';
import { FETCH_ANALYTIC_DOMAIN_USERS_USAGE_HISTORY } from './analytic/analyticAdmin/fetchDomainUsersUsageHistory/action';
import { fetchDomainUsersUsageHistorySaga } from './analytic/analyticAdmin/fetchDomainUsersUsageHistory/fetchDomainUsersUsageHistory';
import { FETCH_CALL_ASSISTANT_QUOTA } from './assistant/fetchCallAssistantQuota/action';
import { fetchCallAssistantQuotaSaga } from './assistant/fetchCallAssistantQuota/fetchCallAssistantQuota';
import { FETCH_CHAT_ASSISTANT_QUOTA } from './assistant/fetchChatAssistantQuota/action';
import { fetchChatAssistantQuotaSaga } from './assistant/fetchChatAssistantQuota/fetchChatAssistantQuota';
import { FETCH_ANALYTIC_USER_DATA } from './analytic/analyticData/fetchUserData/action';
import { fetchUserDataSaga } from './analytic/analyticData/fetchUserData/fetchUserData';
import { FETCH_ANALYTIC_TEAM_DATA } from './analytic/analyticData/fetchTeamData/action';
import { fetchTeamDataSaga } from './analytic/analyticData/fetchTeamData/fetchTeamData';
import { FETCH_ANALYTIC_DOMAIN_DATA } from './analytic/analyticData/fetchDomainData/action';
import { fetchDomainDataSaga } from './analytic/analyticData/fetchDomainData/fetchDomainData';
import { FETCH_ANALYTIC_SUBSCRIPTION_USAGE } from './analytic/analyticSubscription/fetchSubscriptionUsage/action';
import { fetchSubscriptionUsageSaga } from './analytic/analyticSubscription/fetchSubscriptionUsage/fetchSubscriptionUsage';
import { FETCH_ANALYTIC_TEAM } from './analytic/analyticTeam/fetchTeam/action';
import { fetchTeamSaga } from './analytic/analyticTeam/fetchTeam/fetchTeam';
import { CREATE_ANALYTIC_TEAM } from './analytic/analyticTeam/createTeam/action';
import { createTeamSaga } from './analytic/analyticTeam/createTeam/createTeam';
import { UPDATE_ANALYTIC_TEAM } from './analytic/analyticTeam/updateTeam/action';
import { updateTeamSaga } from './analytic/analyticTeam/updateTeam/updateTeam';
import { DELETE_ANALYTIC_TEAM } from './analytic/analyticTeam/deleteTeam/action';
import { deleteTeamSaga } from './analytic/analyticTeam/deleteTeam/deleteTeam';
import { FETCH_ANALYTIC_TEAM_MEMBER } from './analytic/analyticTeamMember/fetchTeamMember/action';
import { fetchTeamMemberSaga } from './analytic/analyticTeamMember/fetchTeamMember/fetchTeamMember';
import { ADD_ANALYTIC_TEAM_MEMBER } from './analytic/analyticTeamMember/addTeamMember/action';
import { addTeamMemberSaga } from './analytic/analyticTeamMember/addTeamMember/addTeamMember';
import { REMOVE_ANALYTIC_TEAM_MEMBER } from './analytic/analyticTeamMember/removeTeamMember/action';
import { removeTeamMemberSaga } from './analytic/analyticTeamMember/removeTeamMember/removeTeamMember';
import { UPDATE_ANALYTIC_TEAM_MEMBER } from './analytic/analyticTeamMember/updateTeamMember/action';
import { updateTeamMemberSaga } from './analytic/analyticTeamMember/updateTeamMember/updateTeamMember';
import { FETCH_ANALYTIC_TEAM_REPORT_CONFIG } from './analytic/analyticTeamReport/fetchTeamReportConfig/action';
import { fetchTeamReportConfigSaga } from './analytic/analyticTeamReport/fetchTeamReportConfig/fetchTeamReportConfig';
import { CREATE_ANALYTIC_TEAM_REPORT_CONFIG } from './analytic/analyticTeamReport/createTeamReportConfig/action';
import { createTeamReportConfigSaga } from './analytic/analyticTeamReport/createTeamReportConfig/createTeamReportConfig';
import { UPDATE_ANALYTIC_TEAM_REPORT_CONFIG } from './analytic/analyticTeamReport/updateTeamReportConfig/action';
import { updateTeamReportConfigSaga } from './analytic/analyticTeamReport/updateTeamReportConfig/updateTeamReportConfig';
import { DELETE_ANALYTIC_TEAM_REPORT_CONFIG } from './analytic/analyticTeamReport/deleteTeamReportConfig/action';
import { deleteTeamReportConfigSaga } from './analytic/analyticTeamReport/deleteTeamReportConfig/deleteTeamReportConfig';
import { GENERATE_ANALYTIC_TEAM_REPORT } from './analytic/analyticTeamReport/generateTeamReport/action';
import { generateTeamReportSaga } from './analytic/analyticTeamReport/generateTeamReport/generateTeamReport';
import { FETCH_CALL_PARK } from './callPark/fetchCallPark/action';
import { fetchCallParkSaga } from './callPark/fetchCallPark/fetchCallPark';
import { FETCH_CALL_QUEUE } from './callQueue/fetchCallQueue/action';
import { fetchCallQueueSaga } from './callQueue/fetchCallQueue/fetchCallQueue';
import { PICK_PARKED_CALL } from './callPark/pickParkedCall/action';
import { pickParkedCallSaga } from './callPark/pickParkedCall/pickParkedCall';
import { START_CALL_RECORDING } from './callRecording/startCallRecording/action';
import { startCallRecordingSaga } from './callRecording/startCallRecording/startCallRecording';
import { STOP_CALL_RECORDING } from './callRecording/stopCallRecording/action';
import { stopCallRecordingSaga } from './callRecording/stopCallRecording/stopCallRecording';
import { FETCH_CONTACT } from './contact/fetchContact/action';
import { fetchContactSaga } from './contact/fetchContact/fetchContact';
import { ADD_CONTACT } from './contact/addContact/action';
import { addContactSaga } from './contact/addContact/addContact';
import { UPDATE_CONTACT } from './contact/updateContact/action';
import { updateContactSaga } from './contact/updateContact/updateContact';
import { DELETE_CONTACT } from './contact/deleteContact/action';
import { deleteContactSaga } from './contact/deleteContact/deleteContact';
import { FETCH_MESSAGE_SESSION } from './message/fetchMessageSession/action';
import { fetchMessageSessionSaga } from './message/fetchMessageSession/fetchMessageSession';
import { FETCH_MESSAGE } from './message/fetchMessage/action';
import { fetchMessageSaga } from './message/fetchMessage/fetchMessage';
import { FETCH_MESSAGE_SUMMARY } from './message/fetchMessageSummary/action';
import { fetchMessageSummarySaga } from './message/fetchMessageSummary/fetchMessageSummary';
import { UPDATE_MESSAGE_SESSION_STATUS } from './message/updateMessageSession/action';
import { updateMessageSessionStatusSaga } from './message/updateMessageSession/updateMessageSession';
import { UPDATE_MESSAGE_SESSION_NOTIFICATION } from './message/updateMessageSession/action';
import { updateMessageSessionNotificationSaga } from './message/updateMessageSession/updateMessageSession';
import { DELETE_MESSAGE_SESSION } from './message/deleteMessageSession/action';
import { deleteMessageSessionSaga } from './message/deleteMessageSession/deleteMessageSession';
import { SEND_MESSAGE } from './message/sendMessage/action';
import { sendMessageSaga } from './message/sendMessage/sendMessage';
import { ADD_TEMPORARY_MESSAGE_SESSION } from './message/handleTemporaryMessageSession/action';
import { addTemporaryMessageSessionSaga } from './message/handleTemporaryMessageSession/handleTemporaryMessageSession';
import { UPDATE_CONVERSATION_NAME } from './message/updateConversationName/action';
import { updateConversationNameSaga } from './message/updateConversationName/updateConversationName';
import { LEAVE_CONVERSATION } from './message/leaveConversation/action';
import { leaveConversationSaga } from './message/leaveConversation/leaveConversation';
import { UPDATE_CONVERSATION_PARTICIPANTS } from './message/updateConversationParticipants/action';
import { updateConversationParticipantsSaga } from './message/updateConversationParticipants/updateConversationParticipants';
import { FETCH_VOICEMAIL } from './voicemail/fetchVoicemail/action';
import { fetchVoicemailSaga } from './voicemail/fetchVoicemail/fetchVoicemail';
import { SAVE_VOICEMAIL } from './voicemail/saveVoicemail/action';
import { saveVoicemailSaga } from './voicemail/saveVoicemail/saveVoicemail';
import { DELETE_VOICEMAIL } from './voicemail/deleteVoicemail/action';
import { deleteVoicemailSaga } from './voicemail/deleteVoicemail/deleteVoicemail';
import { FORWARD_VOICEMAIL } from './voicemail/forwardVoicemail/action';
import { forwardVoicemailSaga } from './voicemail/forwardVoicemail/forwardVoicemail';
import { FETCH_FEEDBACK } from './feedback/fetchfeedback/action';
import { fetchFeedbackSaga } from './feedback/fetchfeedback/fetchFeedback';
import { SUBMIT_FEEDBACK } from './feedback/submitFeedback/action';
import { submitFeedbackSaga } from './feedback/submitFeedback/submitFeedback';
import { LOAD_AUDIO_DEVICE } from './audioDevice/loadAudioDevice/action';
import { loadAudioDeviceSaga } from './audioDevice/loadAudioDevice/loadAudioDevice';
import { CHANGE_AUDIO_DEVICE } from './audioDevice/changeAudioDevice/action';
import { changeAudioDeviceSaga } from './audioDevice/changeAudioDevice/changeAudioDevice';
import { CHANGE_RINGTONE } from './audioDevice/changeRingtone/action';
import { changeRingtoneSaga } from './audioDevice/changeRingtone/changeRingtone';
import { CHANGE_SPEAKER_VOLUME } from './audioDevice/changeVolume/action';
import { changeSpeakerVolumeSaga } from './audioDevice/changeVolume/changeSpeakerVolume';
import { CHANGE_NOTIFICATION_VOLUME } from './audioDevice/changeVolume/action';
import { changeNotificationVolumeSaga } from './audioDevice/changeVolume/changeSpeakerVolume';
import { LOAD_NOTIFICATIONS } from './notification/loadNotifications/action';
import { loadNotificationsSaga } from './notification/loadNotifications/loadNotifications';
import { SAVE_NOTIFICATIONS } from './notification/saveNotifications/action';
import { saveNotificationsSaga } from './notification/saveNotifications/saveNotifications';
import { watchNotificationChangesSaga } from './notification/watchNotificationsChanges/watchNotificationChangesSaga';
import { watchSseSaga } from './sse/watchSse/watchSseSaga';
import { SOCKET_DISCONNECT } from './socket/socketDisconnect/action';
import { socketDisconnectSaga } from './socket/socketDisconnect/socketDisconnect';
import { ON_CONNECT } from './userAgent/onConnect/action';
import { onConnectSaga } from './userAgent/onConnect/onConnect';
import { ON_DISCONNECT } from './userAgent/onDisconnect/action';
import { onDisconnectSaga } from './userAgent/onDisconnect/onDisconnect';
import { ON_INVITE } from './userAgent/onInvite/action';
import { onInviteSaga } from './userAgent/onInvite/onInvite';
import { ATTEMPT_RECONNECT } from './userAgent/attemptReconnect/action';
import { attemptReconnectSaga } from './userAgent/attemptReconnect/attemptReconnect';
import { INITIATE_CALL } from './userAgent/initiateCall/action';
import { initiateCallSaga } from './userAgent/initiateCall/initiateCall';
import { ADD_CALL_SESSION } from './callSessions/addCallSession/action';
import { addCallSessionSaga } from './callSessions/addCallSession/addCallSession';
import { UPDATE_CALL_SESSION } from './callSessions/updateCallSession/action';
import { updateCallSessionSaga } from './callSessions/updateCallSession/updateCallSession';
import { REMOVE_CALL_SESSION } from './callSessions/removeCallSession/action';
import { removeCallSessionSaga } from './callSessions/removeCallSession/removeCallSession';
import { REMOVE_INCOMING_CALL } from './callSessions/removeIncomingCall/action';
import { removeIncomingCallSaga } from './callSessions/removeIncomingCall/removeIncomingCall';
import { ACCEPT_CALL } from './userAgent/acceptCall/action';
import { acceptCallSaga } from './userAgent/acceptCall/acceptCall';
import { IGNORE_CALL } from './userAgent/ignoreCall/action';
import { ignoreCallSaga } from './userAgent/ignoreCall/ignoreCall';
import { REJECT_CALL } from './userAgent/rejectCall/action';
import { rejectCallSaga } from './userAgent/rejectCall/rejectCall';
import { MERGE_CALL_SESSIONS } from './conferenceCall/mergeCallSessions/action';
import { mergeCallSessionsSaga } from './conferenceCall/mergeCallSessions/mergeCallSessions';
import { END_CONFERENCE_CALL_SESSION } from './conferenceCall/endConferenceCallSession/action';
import { endConferenceCallSessionSaga } from './conferenceCall/endConferenceCallSession/endConferenceCallSession';
import { UPDATE_CONFERENCE_PARTICIPANT_LIST } from './conferenceCall/updateConferenceParticipantList/action';
import { updateConferenceParticipantListSaga } from './conferenceCall/updateConferenceParticipantList/updateConferenceParticipantList';
import { MUTE_CONFERENCE_PARTICIPANT } from './conferenceCall/muteConferenceParticipant/action';
import { muteConferenceParticipantSaga } from './conferenceCall/muteConferenceParticipant/muteConferenceParticipant';
import { UNMUTE_CONFERENCE_PARTICIPANT } from './conferenceCall/unmuteConferenceParticipant/action';
import { unmuteConferenceParticipantSaga } from './conferenceCall/unmuteConferenceParticipant/unmuteConferenceParticipant';
import { REMOVE_CONFERENCE_PARTICIPANT } from './conferenceCall/removeConferenceParticipant/action';
import { removeConferenceParticipantSaga } from './conferenceCall/removeConferenceParticipant/removeConferenceParticipant';
import { HANDLE_CALL_NOTIFICATION } from './notification/handleCallNotification/action';
import { handleCallNotificationSaga } from './notification/handleCallNotification/handleCallNotification';
import { FETCH_ACTIVE_DOMAIN_CALL } from './callCenter/fetchActiveDomainCall/action';
import { fetchActiveDomainCallSaga } from './callCenter/fetchActiveDomainCall/fetchActiveDomainCall';
import { TAP_ACTIVE_CALL } from './callCenter/tapActiveCall/action';
import { tapActiveCallSaga } from './callCenter/tapActiveCall/tapActiveCall';
import { FETCH_DOMAIN_INFO } from './callCenter/fetchDomainInfo/action';
import { fetchDomainInfoSaga } from './callCenter/fetchDomainInfo/fetchDomainInfo';
import { FETCH_DOMAIN_CALL_COUNT } from './callCenter/fetchDomainCallCount/action';
import { fetchDomainCallCountSaga } from './callCenter/fetchDomainCallCount/fetchDomainCallCount';
import { FETCH_USER_CALL_REPORT } from './callCenter/fetchUserCallReport/action';
import { fetchUserCallReportSaga } from './callCenter/fetchUserCallReport/fetchUserCallReport';
import { FETCH_DOMAIN_CALL_REPORT } from './callCenter/fetchDomainCallReport/action';
import { fetchDomainCallReportSaga } from './callCenter/fetchDomainCallReport/fetchDomainCallReport';
import { FETCH_CRM_STATUS } from './integration/fetchCrmStatus/action';
import { fetchCrmStatusSaga } from './integration/fetchCrmStatus/fetchCrmStatus';
import { FETCH_CRM_CATALOG } from './integration/fetchCrmCatalog/action';
import { fetchCrmCatalogSaga } from './integration/fetchCrmCatalog/fetchCrmCatalog';
import { CONNECT_CRM } from './integration/connectCrm/action';
import { connectCrmSaga } from './integration/connectCrm/connectCrm';
import { DISCONNECT_CRM } from './integration/disconnectCrm/action';
import { disconnectCrmSaga } from './integration/disconnectCrm/disconnectCrm';
import { SET_DEFAULT_CRM } from './integration/setDefaultCrm/action';
import { setDefaultCrmSaga } from './integration/setDefaultCrm/setDefaultCrm';
import { LOOKUP_CRM_CONTACT } from './integration/lookupCrmContact/action';
import { lookupCrmContactSaga } from './integration/lookupCrmContact/lookupCrmContact';
import { LOG_CALL_CRM } from './integration/logCallCrm/action';
import { logCallCRMSaga } from './integration/logCallCrm/logCallCrm';
import { SEND_LOGS } from './logs/sendLogs/action';
import { sendLogsSaga } from './logs/sendLogs/sendLogs';

// ... import other sagas here


export default function* rootSaga() {
  yield all([
    takeLatest(LOGIN_REQUEST, loginSaga),
    takeLatest(POST_LOGIN, postLoginSaga),
    takeLatest(LOGOUT_REQUEST, logoutSaga),
    takeLatest(INITIALIZE_APP, initializeAppSaga),
    takeLatest(REFRESH_TOKEN, refreshAccessTokenSaga),
    takeLatest(START_TOKEN_REFRESH_TIMER, startTokenRefreshTimerSaga),
    takeLatest(SYSTEM_SUSPEND, systemSuspendSaga),
    takeLatest(SYSTEM_RESUME, systemResumeSaga),
    takeLatest(CHECK_DEVICE, checkDeviceSaga),
    takeLatest(CREATE_DEVICE, createDeviceSaga),
    takeLatest(FETCH_PORTAL_CONFIG, fetchPortalConfigSaga),
    takeLatest(LOAD_AUDIO_DEVICE, loadAudioDeviceSaga),
    takeLatest(CHANGE_AUDIO_DEVICE, changeAudioDeviceSaga),
    takeLatest(CHANGE_RINGTONE, changeRingtoneSaga),
    takeLatest(CHANGE_SPEAKER_VOLUME, changeSpeakerVolumeSaga),
    takeLatest(CHANGE_NOTIFICATION_VOLUME, changeNotificationVolumeSaga),
    takeEvery(LOAD_NOTIFICATIONS, loadNotificationsSaga),
    takeEvery(SAVE_NOTIFICATIONS, saveNotificationsSaga),
    fork(watchNotificationChangesSaga),
    takeLatest(FETCH_SMS_NUMBER, fetchSMSNumberSaga),
    takeLatest(FETCH_CALL_HISTORY, fetchCallHistorySaga),
    takeLatest(FETCH_CALL_RECORDING, fetchCallRecordingSaga),
    takeEvery(PROCESS_CALL_RECORDING, processCallRecordingSaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_SETTINGS, fetchDomainSettingsSaga),
    takeLatest(UPDATE_ANALYTIC_DOMAIN_SETTINGS, updateDomainSettingsSaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_USERS, fetchDomainUsersSaga),
    takeLatest(UPDATE_ANALYTIC_DOMAIN_USER, updateDomainUserSaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_USAGE_SNAPSHOT, fetchDomainUsageSnapshotSaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_USERS_USAGE_SNAPSHOT, fetchDomainUsersUsageSnapshotSaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_USAGE_HISTORY, fetchDomainUsageHistorySaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_USERS_USAGE_HISTORY, fetchDomainUsersUsageHistorySaga),
    takeLatest(FETCH_CALL_ASSISTANT_QUOTA, fetchCallAssistantQuotaSaga),
    takeLatest(FETCH_CHAT_ASSISTANT_QUOTA, fetchChatAssistantQuotaSaga),
    takeLatest(FETCH_ANALYTIC_USER_DATA, fetchUserDataSaga),
    takeLatest(FETCH_ANALYTIC_TEAM_DATA, fetchTeamDataSaga),
    takeLatest(FETCH_ANALYTIC_DOMAIN_DATA, fetchDomainDataSaga),
    takeLatest(FETCH_ANALYTIC_SUBSCRIPTION_USAGE, fetchSubscriptionUsageSaga),
    takeLatest(FETCH_ANALYTIC_TEAM, fetchTeamSaga),
    takeLatest(CREATE_ANALYTIC_TEAM, createTeamSaga),
    takeLatest(UPDATE_ANALYTIC_TEAM, updateTeamSaga),
    takeLatest(DELETE_ANALYTIC_TEAM, deleteTeamSaga),
    takeLatest(FETCH_ANALYTIC_TEAM_MEMBER, fetchTeamMemberSaga),
    takeLatest(ADD_ANALYTIC_TEAM_MEMBER, addTeamMemberSaga),
    takeLatest(REMOVE_ANALYTIC_TEAM_MEMBER, removeTeamMemberSaga),
    takeLatest(UPDATE_ANALYTIC_TEAM_MEMBER, updateTeamMemberSaga),
    takeLatest(FETCH_ANALYTIC_TEAM_REPORT_CONFIG, fetchTeamReportConfigSaga),
    takeLatest(CREATE_ANALYTIC_TEAM_REPORT_CONFIG, createTeamReportConfigSaga),
    takeLatest(UPDATE_ANALYTIC_TEAM_REPORT_CONFIG, updateTeamReportConfigSaga),
    takeLatest(DELETE_ANALYTIC_TEAM_REPORT_CONFIG, deleteTeamReportConfigSaga),
    takeLatest(GENERATE_ANALYTIC_TEAM_REPORT, generateTeamReportSaga),
    takeLatest(FETCH_CALL_PARK, fetchCallParkSaga),
    takeLatest(FETCH_CALL_QUEUE, fetchCallQueueSaga),
    takeLatest(PICK_PARKED_CALL, pickParkedCallSaga),
    takeLatest(START_CALL_RECORDING, startCallRecordingSaga),
    takeLatest(STOP_CALL_RECORDING, stopCallRecordingSaga),
    takeLatest(FETCH_CONTACT, fetchContactSaga),
    takeLatest(ADD_CONTACT, addContactSaga),
    takeLatest(UPDATE_CONTACT, updateContactSaga),
    takeLatest(DELETE_CONTACT, deleteContactSaga),
    takeLatest(FETCH_MESSAGE_SESSION, fetchMessageSessionSaga),
    takeLatest(FETCH_MESSAGE, fetchMessageSaga),
    takeLatest(FETCH_MESSAGE_SUMMARY, fetchMessageSummarySaga),
    takeEvery(UPDATE_MESSAGE_SESSION_STATUS, updateMessageSessionStatusSaga),
    takeEvery(UPDATE_MESSAGE_SESSION_NOTIFICATION, updateMessageSessionNotificationSaga),
    takeEvery(DELETE_MESSAGE_SESSION, deleteMessageSessionSaga),
    takeLatest(SEND_MESSAGE, sendMessageSaga),
    takeEvery(ADD_TEMPORARY_MESSAGE_SESSION, addTemporaryMessageSessionSaga),
    takeLatest(UPDATE_CONVERSATION_NAME, updateConversationNameSaga),
    takeLatest(LEAVE_CONVERSATION, leaveConversationSaga),
    takeLatest(UPDATE_CONVERSATION_PARTICIPANTS, updateConversationParticipantsSaga),
    takeLatest(FETCH_VOICEMAIL, fetchVoicemailSaga),
    takeLatest(SAVE_VOICEMAIL, saveVoicemailSaga),
    takeLatest(DELETE_VOICEMAIL, deleteVoicemailSaga),
    takeLatest(FORWARD_VOICEMAIL, forwardVoicemailSaga),
    takeLatest(FETCH_FEEDBACK, fetchFeedbackSaga),
    takeLatest(SUBMIT_FEEDBACK, submitFeedbackSaga),
    fork(watchSseSaga),
    takeLatest(SOCKET_DISCONNECT, socketDisconnectSaga),
    takeLatest(ON_CONNECT, onConnectSaga),
    takeLatest(ON_DISCONNECT, onDisconnectSaga),
    takeEvery(ATTEMPT_RECONNECT, attemptReconnectSaga),
    takeLatest(ON_INVITE, onInviteSaga),
    takeLatest(INITIATE_CALL, initiateCallSaga),
    takeEvery(ACCEPT_CALL, acceptCallSaga),
    takeEvery(ADD_CALL_SESSION, addCallSessionSaga),
    takeLatest(REMOVE_CALL_SESSION, removeCallSessionSaga),
    takeLatest(UPDATE_CALL_SESSION, updateCallSessionSaga),
    takeEvery(IGNORE_CALL, ignoreCallSaga),
    takeEvery(REJECT_CALL, rejectCallSaga),
    takeLatest(REMOVE_INCOMING_CALL, removeIncomingCallSaga),
    takeEvery(MERGE_CALL_SESSIONS, mergeCallSessionsSaga),
    takeEvery(END_CONFERENCE_CALL_SESSION, endConferenceCallSessionSaga),
    takeLatest(UPDATE_CONFERENCE_PARTICIPANT_LIST, updateConferenceParticipantListSaga),
    takeEvery(MUTE_CONFERENCE_PARTICIPANT, muteConferenceParticipantSaga),
    takeEvery(UNMUTE_CONFERENCE_PARTICIPANT, unmuteConferenceParticipantSaga),
    takeEvery(REMOVE_CONFERENCE_PARTICIPANT, removeConferenceParticipantSaga),
    takeLatest(HANDLE_CALL_NOTIFICATION, handleCallNotificationSaga),
    takeLatest(FETCH_ACTIVE_DOMAIN_CALL, fetchActiveDomainCallSaga),
    takeLatest(TAP_ACTIVE_CALL, tapActiveCallSaga),
    takeLatest(FETCH_DOMAIN_INFO, fetchDomainInfoSaga),
    takeEvery(FETCH_DOMAIN_CALL_COUNT, fetchDomainCallCountSaga),
    takeLatest(FETCH_USER_CALL_REPORT, fetchUserCallReportSaga),
    takeLatest(FETCH_DOMAIN_CALL_REPORT, fetchDomainCallReportSaga),
    takeEvery(FETCH_CRM_STATUS, fetchCrmStatusSaga),
    takeLatest(FETCH_CRM_CATALOG, fetchCrmCatalogSaga),
    takeLatest(CONNECT_CRM, connectCrmSaga),
    takeLatest(DISCONNECT_CRM, disconnectCrmSaga),
    takeLatest(SET_DEFAULT_CRM, setDefaultCrmSaga),
    takeLatest(LOOKUP_CRM_CONTACT, lookupCrmContactSaga),
    takeEvery(LOG_CALL_CRM, logCallCRMSaga),
    takeLatest(SEND_LOGS, sendLogsSaga),

  ]);
}
